import 'antd/dist/antd.css';
import './notification.css';
import AppRoutes from 'routing/AppRoutes';

function App() {
	return <AppRoutes />;
}

export default App;
